import { KYMW2000Model } from '../kymw2000.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { TempSelectedSummaryByBuyer } from '../vo/temp-selected-summary-by-buyer.model';

// レスポンス構造
interface GetPlanTempSelectedSummaryByBuyerResponse {
  SelectedNumList: {
    MediumType: string,
    MediumName: string,
    ClassCode: string,
    ClassName: string,
    BuyerCode: string,
    BuyerName: string,
    FreezedGoodsCount: number,
    RefrigeratedGoodsCount: number,
    RoomTempGoodsCount: number,
    VegetableGoodsCount: number,
    BreadGoodsCount: number,
    OtherStockedGoodsCount: number,
  }[],
  SelectedTotalNum: {
    FreezedGoodsCount: number,
    RefrigeratedGoodsCount: number,
    RoomTempGoodsCount: number,
    VegetableGoodsCount: number,
    BreadGoodsCount: number,
    OtherStockedGoodsCount: number,
  },
}

/**
 * サイクル商品選定対象媒体一覧取得するサービス
 *
 * @export GetPlanTempSelectedSummaryByBuyerService
 * @class GetPlanTempSelectedSummaryByBuyerService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetPlanTempSelectedSummaryByBuyerService extends PlessJsonResponderSub<any> {

  private model: KYMW2000Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPlanTempSelectedSummaryByBuyerService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        GetPlanTempSelectedSummaryByBuyer: {
          condition: {
            MediumType: this.model.mediumType,
            OrderCode: this.model.orderCode,
            CoopCode: this.model.buyerCoopCode,
          }
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetPlanTempSelectedSummaryByBuyerService
   */
  execute(model: KYMW2000Model, f?: () => void): void {
    this.model = model;
    this.calbak = f;
    this.send('getPlanTempSelectedSummaryByBuyer', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPlanTempSelectedSummaryByBuyerService
   */
  success(data: GetPlanTempSelectedSummaryByBuyerResponse): void {
    if (data !== null) {
      this.model.tempBuyerRaw = [
        new TempSelectedSummaryByBuyer(data.SelectedNumList, data.SelectedTotalNum)
      ];
      if (this.calbak) this.calbak();
    }
  }
}
